export default __webpack_public_path__ + "static/3-df6d449270d52466f7aa089f39c632f6.jpeg";